module.exports = __webpack_public_path__ + "static/media/baojiahan.1bc70d3f.png";